export default "<img class=\"qrcode\"></img>"